import CssBaseline from "@mui/material/CssBaseline";
import AppTheme from "../theme/AppTheme";
import AppAppBar from "../components/AppAppBar";
import Footer from "../components/Footer";
import TrainingEnSection from "../components/TrainingEn";
import TrainingJpSection from "../components/TrainingJp";
import { useTranslation } from "react-i18next";
import FloatingSocialButtons from "../components/FloatingSocialButtons";

export default function Training(props: { disableCustomTheme?: boolean }) {
  const { i18n } = useTranslation();
  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />

      <AppAppBar />
      <FloatingSocialButtons />
      <div>
        {i18n.language === "en" ? <TrainingEnSection /> : <TrainingJpSection />}
        <Footer />
      </div>
    </AppTheme>
  );
}
